import React, { useState } from 'react';
import { CreditCardIcon, UsersIcon, HomeIcon, SlidersHorizontalIcon, CalendarIcon, PencilIcon, MailIcon, BadgeCheckIcon, Trash2Icon, DownloadIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon, XIcon } from 'lucide-react';
// --- MOCK DATA ---
type ApprovalStatus = 'approved' | 'pending' | 'none' | 'unconfirmed' | 'no-card' | 'not-generated';
interface UserRecord {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  cardStatus: ApprovalStatus;
  cardNumber?: string;
  familyStatus: ApprovalStatus;
  familyCount?: number;
  propertyStatus: ApprovalStatus;
  propertyCount?: number;
  emailConfirmed: boolean;
}
const MOCK_DATA: UserRecord[] = [{
  id: '1',
  firstName: 'Hugo',
  lastName: 'Janelle',
  email: 'hugo.janelle@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040340859',
  familyStatus: 'approved',
  familyCount: 2,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '2',
  firstName: 'Hugo',
  lastName: 'Morrissette',
  email: 'hugomorrissette3@gmail.com',
  cardStatus: 'no-card',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '3',
  firstName: 'Hugo',
  lastName: 'Delgado',
  email: 'hugofernandod@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040341885',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '4',
  firstName: 'Hugo',
  lastName: 'Delgado',
  email: 'minihugojuan@gmail.com',
  cardStatus: 'no-card',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '5',
  firstName: 'Hugo',
  lastName: 'Delgado',
  email: 'monihugojuan@gmail.com',
  cardStatus: 'not-generated',
  familyStatus: 'approved',
  familyCount: 2,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '6',
  firstName: 'yovanna',
  lastName: 'chavez',
  email: 'giocha2403@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'approved',
  familyCount: 1,
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '7',
  firstName: 'Julia',
  lastName: 'Nayar',
  email: 'julialnayar@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '8',
  firstName: 'Amaury',
  lastName: 'Marqué',
  email: 'amaury.marque@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'none',
  propertyStatus: 'pending',
  emailConfirmed: true
}, {
  id: '9',
  firstName: 'Lilyanna',
  lastName: 'Duff',
  email: 'N/D',
  cardStatus: 'pending',
  familyStatus: 'pending',
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '10',
  firstName: 'Marianne Rose',
  lastName: 'De Leon',
  email: 'marosedel@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'pending',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '11',
  firstName: 'Peter',
  lastName: 'Lefebvre',
  email: 'peterlefebvre2002@yahoo.ca',
  cardStatus: 'approved',
  cardNumber: '0040340839',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '12',
  firstName: 'Jimmy',
  lastName: 'Cineas',
  email: 'jammeeskillz@live.fr',
  cardStatus: 'approved',
  cardNumber: '0040340827',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '13',
  firstName: 'koorosh',
  lastName: 'Nikgotar',
  email: 'kooroshnikgoftar1380@gmail.com',
  cardStatus: 'not-generated',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '14',
  firstName: 'Lucia',
  lastName: 'Cassagnet',
  email: 'lucia.cassagnet@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040343922',
  familyStatus: 'approved',
  familyCount: 1,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '15',
  firstName: 'Cynthia',
  lastName: 'DEGNI',
  email: 'cybelle225@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040341208',
  familyStatus: 'approved',
  familyCount: 4,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '16',
  firstName: 'Florence Michelle',
  lastName: 'Niéba',
  email: 'odetteleontin15@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'none',
  propertyStatus: 'approved',
  propertyCount: 1,
  emailConfirmed: true
}];
type QuickFilter = 'none' | 'cartes' | 'liens' | 'proprietes';
export function BcitiIdSearch() {
  const [quickFilter, setQuickFilter] = useState<QuickFilter>('none');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  // Filter logic
  const filteredData = MOCK_DATA.filter(user => {
    if (quickFilter === 'cartes') return user.cardStatus === 'pending';
    if (quickFilter === 'liens') return user.familyStatus === 'pending';
    if (quickFilter === 'proprietes') return user.propertyStatus === 'pending';
    return true;
  });
  // Render helpers
  const renderCardStatus = (user: UserRecord) => {
    if (user.cardStatus === 'pending') return <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold" data-id="element-932" data-mp="2vil1r8sd4n7q">
          Approbation requise
        </span>;
    if (user.cardStatus === 'no-card') return <span className="text-slate-400 italic text-sm" data-id="element-933" data-mp="2y42lyfrlzdwa">Pas de carte</span>;
    if (user.cardStatus === 'not-generated') return <span className="text-slate-400 italic text-sm flex items-center gap-1" data-id="element-934" data-mp="3358b63m28j12">
          <CreditCardIcon className="w-3.5 h-3.5" data-id="element-935" data-mp="2p5qktjt48xpl" /> Numéro non généré
        </span>;
    return <span className="text-slate-700 text-sm flex items-center gap-1" data-id="element-936" data-mp="2t6iuge5wh4me">
        <CreditCardIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-937" data-mp="3gutqn40nig4c" />{' '}
        {user.cardNumber}
      </span>;
  };
  const renderFamilyStatus = (user: UserRecord) => {
    if (user.familyStatus === 'pending') return <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold cursor-pointer hover:bg-amber-200 transition-colors" data-id="element-938" data-mp="383te4asp5gt7">
          Voir la demande
        </span>;
    if (user.familyStatus === 'approved') return <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-bold" data-id="element-939" data-mp="3nijaty0gkg1">
          {user.familyCount} lien(s)
        </span>;
    return <span className="text-slate-400 italic text-sm" data-id="element-940" data-mp="ibsc6i2ucaip">Aucun lien</span>;
  };
  const renderPropertyStatus = (user: UserRecord) => {
    if (user.propertyStatus === 'pending') return <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold cursor-pointer hover:bg-amber-200 transition-colors" data-id="element-941" data-mp="9au8k0wbe50n">
          Voir la demande
        </span>;
    if (user.propertyStatus === 'approved') return <span className="text-slate-700 text-sm" data-id="element-942" data-mp="3vj2dthiw26mj">
          {user.propertyCount} résidence
        </span>;
    return <span className="text-slate-400 italic text-sm" data-id="element-943" data-mp="3qqisfydym776">Aucune</span>;
  };
  return <div className="flex flex-col gap-4 animate-in fade-in duration-300 font-body" data-id="element-944" data-mp="3moxjup8gkf2s">
      {/* TOOLBAR */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-945" data-mp="3hroyygvxdwxu">
        <div className="flex flex-wrap items-center gap-2" data-id="element-946" data-mp="3crssmazr9tf4">
          <button onClick={() => setQuickFilter(quickFilter === 'cartes' ? 'none' : 'cartes')} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors border ${quickFilter === 'cartes' ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-947" data-mp="3ctdmrzi5racg">
            <CreditCardIcon className="w-4 h-4" data-id="element-948" data-mp="37mfmvgh458q5" />
            Cartes à approuver
            <span className={`text-xs ${quickFilter === 'cartes' ? 'text-slate-300' : 'text-slate-400'}`} data-id="element-949" data-mp="3clienz831ig6">
              18
            </span>
          </button>

          <button onClick={() => setQuickFilter(quickFilter === 'liens' ? 'none' : 'liens')} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors border ${quickFilter === 'liens' ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-950" data-mp="2ezur83tluags">
            <UsersIcon className="w-4 h-4" data-id="element-951" data-mp="1w7s7gjlo2e2b" />
            Liens familiaux à approuver
            <span className={`text-xs ${quickFilter === 'liens' ? 'text-slate-300' : 'text-slate-400'}`} data-id="element-952" data-mp="216n3in8n9z4d">
              9
            </span>
          </button>

          <button onClick={() => setQuickFilter(quickFilter === 'proprietes' ? 'none' : 'proprietes')} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors border ${quickFilter === 'proprietes' ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-953" data-mp="3fdllgpqc8zqc">
            <HomeIcon className="w-4 h-4" data-id="element-954" data-mp="26bk7re7d5n1" />
            Propriétés à approuver
            <span className={`text-xs ${quickFilter === 'proprietes' ? 'text-slate-300' : 'text-slate-400'}`} data-id="element-955" data-mp="24766gmlaq91">
              5
            </span>
          </button>

          <button onClick={() => setShowAdvancedFilters(true)} className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium bg-white text-slate-600 border border-slate-200 hover:bg-slate-50 transition-colors" data-id="element-956" data-mp="bvv1ism9orfs">
            <SlidersHorizontalIcon className="w-4 h-4" data-id="element-957" data-mp="lsg4l8eq7sgz" />
            Plus de filtres
          </button>

          {quickFilter !== 'none' && <button onClick={() => setQuickFilter('none')} className="px-3 py-2 text-sm font-medium text-slate-500 hover:text-slate-800 transition-colors" data-id="element-958" data-mp="10gq074axxwnc">
              Réinitialiser
            </button>}
        </div>

        <button className="bg-[#4F46E5] hover:bg-[#4338CA] text-white px-5 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm whitespace-nowrap" data-id="element-959" data-mp="qjv5kwhsggec">
          Créer un compte
        </button>
      </div>

      {/* SEARCH INPUTS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3" data-id="element-960" data-mp="gr5tbzeeyyhy">
        <input type="text" placeholder="Prénom" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-961" data-mp="lks5zrkkv2dr" />
        <input type="text" placeholder="Nom de famille" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-962" data-mp="cs6umwj9zxyy" />
        <div className="relative" data-id="element-963" data-mp="2vljdtgnxqmo">
          <input type="text" placeholder="Date de naissance" className="w-full pl-3 pr-9 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-964" data-mp="39y6o5g6qeyrs" />
          <CalendarIcon className="absolute right-3 top-2.5 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-965" data-mp="301twsoynsx07" />
        </div>
        <input type="text" placeholder="Courriel" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-966" data-mp="34zvgnc3wt0cq" />
        <input type="text" placeholder="Téléphone" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-967" data-mp="1kze0xnk1wrd" />
        <input type="text" placeholder="Numéro de carte" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-968" data-mp="3nw4r7pflr8rz" />
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden mt-2" data-id="element-969" data-mp="24yrqyyvt2223">
        <div className="overflow-x-auto" data-id="element-970" data-mp="1zzoqzsuomm0z">
          <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-971" data-mp="1zyvudkpftcwk">
            <thead className="bg-[#0F172A] text-white" data-id="element-972" data-mp="2ep31536317hf">
              <tr data-id="element-973" data-mp="29pzzztt83leq">
                <th className="px-4 py-3.5 font-semibold" data-id="element-974" data-mp="29rktrh7pr0bj">Nom</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-975" data-mp="1m0p3ioiwod6e">Courriel</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-976" data-mp="1m31mn50egtl1">
                  Numéro de la carte
                </th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-977" data-mp="1v1nczmc45cwd">Liens familiaux</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-978" data-mp="1uziw83t48jeo">Propriétés</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-979" data-mp="1qz8uj3ccwf5m">Courriel confirmé</th>
                <th className="px-4 py-3.5 font-semibold text-right" data-id="element-980" data-mp="36g0sa2sswk0s"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-981" data-mp="32efaq45bnhk9">
              {filteredData.map(user => <tr key={user.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-982" data-mp="1z52sfq66cqk9">
                  <td className="px-4 py-3 text-slate-700" data-id="element-983" data-mp="242l4vqjehnx0">
                    {user.firstName} {user.lastName}
                  </td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-984" data-mp="292z20djgrdg9">{user.email}</td>
                  <td className="px-4 py-3" data-id="element-985" data-mp="2d317kxsbkr0t">{renderCardStatus(user)}</td>
                  <td className="px-4 py-3" data-id="element-986" data-mp="1ge1th2520v0p">{renderFamilyStatus(user)}</td>
                  <td className="px-4 py-3" data-id="element-987" data-mp="1gbyy02l4u9ol">{renderPropertyStatus(user)}</td>
                  <td className="px-4 py-3" data-id="element-988" data-mp="1ld4ri2mma0z6">
                    {user.emailConfirmed ? <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-bold" data-id="element-989" data-mp="1pdf78707o5r8">
                        Confirmé
                      </span> : <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold" data-id="element-990" data-mp="xnag7phy4kh1">
                        Non confirmé
                      </span>}
                  </td>
                  <td className="px-4 py-3" data-id="element-991" data-mp="u5eabzp28cvq">
                    <div className="flex items-center justify-end gap-3 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-992" data-mp="u439o8qwvl8u">
                      <button className="hover:text-[#4F46E5] transition-colors" title="Modifier" data-id="element-993" data-mp="p4gy03qqed25">
                        <PencilIcon className="w-4 h-4" data-id="element-994" data-mp="l6j78whbbiwn" />
                      </button>
                      <button className="hover:text-[#4F46E5] transition-colors" title="Envoyer un courriel" data-id="element-995" data-mp="g7pq8u2th9rq">
                        <MailIcon className="w-4 h-4" data-id="element-996" data-mp="b8d28607lwnk" />
                      </button>
                      <button className="hover:text-[#4F46E5] transition-colors" title="Carte" data-id="element-997" data-mp="6dpg2dsohec5">
                        <BadgeCheckIcon className="w-4 h-4" data-id="element-998" data-mp="1emkdjyl8kgu" />
                      </button>
                      <button className="hover:text-red-500 transition-colors" title="Supprimer" data-id="element-999" data-mp="3tmcm76vzwmbl">
                        <Trash2Icon className="w-4 h-4" data-id="element-1000" data-mp="3okn79g5njoi8" />
                      </button>
                    </div>
                  </td>
                </tr>)}
              {filteredData.length === 0 && <tr data-id="element-1001" data-mp="1njpfho3x78fu">
                  <td colSpan={7} className="px-4 py-8 text-center text-slate-500" data-id="element-1002" data-mp="1nla8h9al6jbl">
                    Aucun résultat trouvé.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* FOOTER / PAGINATION */}
        <div className="px-4 py-3 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4 bg-slate-50/50" data-id="element-1003" data-mp="1irfg7hgx0w0w">
          <button className="flex items-center gap-2 text-xs font-bold text-[#0F172A] hover:text-[#4F46E5] transition-colors uppercase tracking-wider" data-id="element-1004" data-mp="14usk1gwse9w1">
            <DownloadIcon className="w-4 h-4" data-id="element-1005" data-mp="uvbgp650c838" />
            Exporter les résultats
          </button>

          <div className="flex items-center gap-6 text-xs text-slate-500" data-id="element-1006" data-mp="zsthuacs9j0o">
            <div className="flex items-center gap-2" data-id="element-1007" data-mp="2p8sva3nfpum4">
              <span data-id="element-1008" data-mp="2p9cctj96agzm">Éléments par page</span>
              <select className="bg-transparent font-bold text-slate-700 focus:outline-none cursor-pointer" data-id="element-1009" data-mp="2u7duq0uv4a9i">
                <option data-id="element-1010" data-mp="ijr6m7txsjkk">10</option>
                <option data-id="element-1011" data-mp="iksgwa34p218">20</option>
                <option data-id="element-1012" data-mp="ihy14vv285e5">50</option>
              </select>
            </div>

            <div className="font-medium" data-id="element-1013" data-mp="dn0pdh6ebhxk">1 - {filteredData.length} / 293</div>

            <div className="flex items-center gap-1" data-id="element-1014" data-mp="savjn201xucr">
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1015" data-mp="njnam72mwb04">
                <ChevronsLeftIcon className="w-4 h-4" data-id="element-1016" data-mp="11as5ywyyyh4n" />
              </button>
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1017" data-mp="11cv1txmsz4ha">
                <ChevronLeftIcon className="w-4 h-4" data-id="element-1018" data-mp="wdruu7n9io6o" />
              </button>
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1019" data-mp="1b8fz5igxfgkp">
                <ChevronRightIcon className="w-4 h-4" data-id="element-1020" data-mp="16b69c1pml2wc" />
              </button>
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1021" data-mp="3czjdahq0zda0">
                <ChevronsRightIcon className="w-4 h-4" data-id="element-1022" data-mp="381zy9fli6wh0" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ADVANCED FILTERS MODAL */}
      {showAdvancedFilters && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-1023" data-mp="5kt3wq5mb73d">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col animate-in zoom-in-95 duration-200" data-id="element-1024" data-mp="ajctd0jf710h">
            <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between" data-id="element-1025" data-mp="kjddgop45l5q">
              <h3 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-1026" data-mp="ojx91nu1ggpr">
                Filtres avancés
              </h3>
              <button onClick={() => setShowAdvancedFilters(false)} className="text-slate-400 hover:text-slate-600 transition-colors p-1 rounded-lg hover:bg-slate-50" data-id="element-1027" data-mp="tcgmmksq7buk">
                <XIcon className="w-5 h-5" data-id="element-1028" data-mp="139v3ummh44nx" />
              </button>
            </div>

            <div className="p-6 space-y-6" data-id="element-1029" data-mp="188fububxb9z6">
              <div className="grid grid-cols-2 gap-4" data-id="element-1030" data-mp="1897or1tsb1nv">
                <div data-id="element-1031" data-mp="2sq744ulu3jyg">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1032" data-mp="2sqqloa7ko6by">
                    Statut de carte
                  </label>
                  <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1033" data-mp="2ntgpmbpogwf5">
                    <option data-id="element-1034" data-mp="2du9b3l77ivqg">Tous</option>
                    <option data-id="element-1035" data-mp="2dvaqu2z646ei">Actif</option>
                    <option data-id="element-1036" data-mp="3bhhv1brk7wqc">En création</option>
                    <option data-id="element-1037" data-mp="3bg6s1e5xut0a">En traitement</option>
                    <option data-id="element-1038" data-mp="36hbzhki65q2z">Expiré</option>
                  </select>
                </div>
                <div data-id="element-1039" data-mp="31qn59xf3uf05">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1040" data-mp="31q3nqhtd9smn">
                    Type de compte
                  </label>
                  <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1041" data-mp="2wq7tvbedvhkt">
                    <option data-id="element-1042" data-mp="3pfxy8sq7r53q">Tous</option>
                    <option data-id="element-1043" data-mp="3pewk2fdwi2hs">Administrateur global</option>
                    <option data-id="element-1044" data-mp="2xsd35l2jyge7">Bibliothèque</option>
                    <option data-id="element-1045" data-mp="32jv4ia8hmizp">Loisirs</option>
                  </select>
                </div>
                <div data-id="element-1046" data-mp="32lprrv78en6y">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1047" data-mp="2ot02nhwep25m">
                    Courriel confirmé
                  </label>
                  <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1048" data-mp="2ts2zif28g22i">
                    <option data-id="element-1049" data-mp="3lj0n54pqswh4">Tous</option>
                    <option data-id="element-1050" data-mp="3lhxwmxwc0w1q">Confirmé</option>
                    <option data-id="element-1051" data-mp="37jhg6f8o3r6e">Non confirmé</option>
                  </select>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-100" data-id="element-1052" data-mp="3ch9j04auoxpd">
                <h4 className="text-sm font-bold text-[#0F172A] mb-3" data-id="element-1053" data-mp="1w3ss1kjogm40">
                  Adresse
                </h4>
                <div className="flex gap-3" data-id="element-1054" data-mp="213f5nv3f44dc">
                  <div className="w-24" data-id="element-1055" data-mp="214gr8ti2899b">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1056" data-mp="1tj4ktw9zhh61">
                      Numéro
                    </label>
                    <input type="text" placeholder="123" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1057" data-mp="1oji8dp1zc4ya" />
                  </div>
                  <div className="flex-1" data-id="element-1058" data-mp="1xlrg675v5k7z">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1059" data-mp="19v455d0nieh7">
                      Nom de rue
                    </label>
                    <input type="text" placeholder="Nom de rue" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1060" data-mp="15vdauzbx1g7x" />
                  </div>
                  <div className="w-24" data-id="element-1061" data-mp="1esdw4x3ouy75">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1062" data-mp="r44co1ty6mj6">
                      Code postal
                    </label>
                    <input type="text" placeholder="A1A 1A1" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1063" data-mp="m3qercm28syv" />
                  </div>
                </div>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-slate-100 flex justify-end bg-slate-50/50" data-id="element-1064" data-mp="3oif0qyap58r3">
              <button onClick={() => setShowAdvancedFilters(false)} className="bg-[#4F46E5] hover:bg-[#4338CA] text-white px-5 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm" data-id="element-1065" data-mp="3joj6a5tn640o">
                Appliquer les filtres
              </button>
            </div>
          </div>
        </div>}
    </div>;
}